import { Shield } from "lucide-react";

const PromiseSection = () => {
  return (
    <section aria-labelledby="promise-heading" className="py-16 bg-navy relative">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="relative p-8 md:p-12 rounded-3xl bg-gradient-to-br from-gold/10 to-gold/5 border border-gold/30">
            {/* Decorative corner */}
            <div className="absolute top-0 right-0 w-24 h-24 border-t-2 border-r-2 border-gold/30 rounded-tr-3xl" aria-hidden="true" />
            <div className="absolute bottom-0 left-0 w-24 h-24 border-b-2 border-l-2 border-gold/30 rounded-bl-3xl" aria-hidden="true" />
            
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
              <div className="w-20 h-20 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0">
                <Shield className="w-10 h-10 text-gold" aria-hidden="true" />
              </div>
              
              <div className="text-center md:text-right">
                <h2 id="promise-heading" className="text-2xl md:text-3xl font-bold text-cream mb-4">
                  ההבטחה שלנו
                </h2>
                <p className="text-lg md:text-xl text-cream/90 leading-relaxed">
                  לא נציע לכם מישהו ש"נראה טוב" אבל רוצה חיים הפוכים מכם.
                  <br />
                  <span className="text-gold font-semibold">זה בזבוז זמן. שלכם ושלנו.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromiseSection;
